import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useModal } from '../../../context/ModalContext';
import { isLogin } from '../../../utils/auth';

function MainServiceSection() {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  return (
    <Section>
      <BalanceBox
        onClick={() => {
          navigate('/game');
        }}
      >
        <FirstBox>
          <ImgBox>
            <img src="/assets/images/icon/icon_trophy.svg" />
          </ImgBox>
          <div>
            <LastText>나한테 딱 맞는 경매 물건은?</LastText>
            <FirstText>
              경매 밸런스 게임 바로가기
              <Marker>NEW</Marker>
            </FirstText>
          </div>
        </FirstBox>
        <LastBox>
          <img src="/assets/images/arrow/Arrow-right-white.svg" />
        </LastBox>
      </BalanceBox>
      <AISearchCard onClick={() => window.open('/chat', '_blank')}>
        <CardTitle>AI 경공매찾기</CardTitle>
        <CardDescription>
          애매한 조건도
          <br />
          챗봇 입력만 하면 검색 가능
        </CardDescription>
        <img src="/assets/images/main/graphic-1.svg" alt="" />
      </AISearchCard>

      <Rowbox>
        <AuctionSearchCard onClick={() => navigate('/search?type=e')}>
          <CardTitle>경공매 검색</CardTitle>
          <CardDescription>
            원하는 조건으로
            <br />
            쉽게 찾기
          </CardDescription>
          <img src="/assets/images/main/graphic-2.svg" alt="" />
        </AuctionSearchCard>

        <Colbox>
          <AIAlgorithmCard
            onClick={() => {
              navigate('/myAlgorithm');
            }}
          >
            <CardTitle className="title">AI 경매 알고리즘</CardTitle>
            <CardDescription className="desc">
              빅데이터로 검증하는
              <br />
              나만의 투자 전략
            </CardDescription>
            <img src="/assets/images/main/graphic-3.svg" alt="" />
          </AIAlgorithmCard>

          <QuantCard onClick={() => navigate('/quant')}>
            <CardTitle>AI 퀀트 분석</CardTitle>
            <CardDescription>
              데이터로
              <br />
              수익 물건 선별
            </CardDescription>
            <img src="/assets/images/main/graphic-4.svg" alt="" />
          </QuantCard>
        </Colbox>
      </Rowbox>

      <LastRowbox>
        <StatCard onClick={() => navigate('/period-stats')}>
          <CardTitle>경공매 통계</CardTitle>
          <img src="/assets/images/main/graphic-7.svg" alt="" />
          <NewLabel>NEW</NewLabel>
        </StatCard>
        <MapCard onClick={() => navigate('/map')}>
          <CardTitle>지도 검색</CardTitle>
          <img src="/assets/images/main/graphic-5.svg" alt="" />
        </MapCard>

        <NPLCard onClick={() => navigate('/search/npl')}>
          <CardTitle>부실채권</CardTitle>
          <img src="/assets/images/main/graphic-6.svg" alt="" />
        </NPLCard>
      </LastRowbox>

      <BottomButtonWrapper>
        <Button onClick={() => navigate('/studyroom')}>
          <img src="/assets/images/icon/pencil-black.svg" alt="" />
          스터디룸
        </Button>
        <Divider />
        <Button
          onClick={() => {
            if (!isLogin()) {
              modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
              return;
            }
            modalDispatch({ type: 'I' });
          }}
        >
          <img src="/assets/images/icon/inquire-dark.svg" alt="" />
          고객센터
        </Button>
      </BottomButtonWrapper>
    </Section>
  );
}

export default MainServiceSection;

const Section = styled.div`
  display: flex;
  padding: 16px 16px 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

const PageCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding: 16px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(220, 228, 232, 0.3);
  position: relative;
  word-break: keep-all;
`;

const AISearchCard = styled(PageCard)`
  gap: 8px;

  & > img {
    position: absolute;
    right: 0;
    bottom: 10px;
  }
`;

const AuctionSearchCard = styled(PageCard)`
  gap: 6px;
  flex: 1;
  /* min-width: 0; */

  & > img {
    position: absolute;
    right: 0;
    bottom: 10px;
  }
`;

const AIAlgorithmCard = styled(PageCard)`
  height: 120px;
  gap: 6px;

  & > img {
    position: absolute;
    right: 16px;
    bottom: 10px;
  }
`;

const QuantCard = styled(PageCard)`
  height: 120px;
  gap: 6px;

  & > img {
    position: absolute;
    right: 16px;
    bottom: 10px;
  }
`;

const StatCard = styled(PageCard)`
  height: 100px;
  flex: 1 0 0;
  & > img {
    position: absolute;
    right: 0;
    bottom: 0;
  }
`;

const NewLabel = styled.div`
  position: absolute;
  left: -4px;
  top: -4px;

  display: flex;
  padding: 0 4px;
  align-items: center;
  border-radius: 999px;
  background: #f45551;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const MapCard = styled(PageCard)`
  height: 100px;
  flex: 1 0 0;

  & > img {
    position: absolute;
    right: 0;
    bottom: 0;
  }
`;

const NPLCard = styled(PageCard)`
  height: 100px;
  gap: 4px;
  flex: 1 0 0;

  & > img {
    position: absolute;
    right: 16px;
    bottom: 10px;
  }
`;

const CardTitle = styled.div`
  color: rgba(0, 12, 30, 0.8);
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const CardDescription = styled.div`
  align-self: stretch;
  color: #6b7684;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
  z-index: 10;
`;

const Rowbox = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  align-self: stretch;

  & > * {
    flex: 1 1 0;
    min-width: 0;
    max-width: calc((100% - 8px) / 2);
  }
`;

const Colbox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 8px;
  flex: 1;
  min-width: 180px;
`;

const LastRowbox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const BottomButtonWrapper = styled.div`
  display: flex;
  padding: 4px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(220, 228, 232, 0.3);
`;

const Button = styled.div`
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex: 1 0 0;
  border-radius: 16px;
  background: #fff;

  color: rgba(0, 12, 30, 0.8);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const Divider = styled.div`
  width: 1px;
  height: 16px;
  background: #e1e2e4;
`;

const BalanceBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  background: #1957c2;
  cursor: pointer;
`;
const FirstBox = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: row;
  align-items: center;
  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }
`;

const ImgBox = styled.div`
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  background: #f3f4f6;
  width: 28px;
  height: 28px;
  img {
    widht: 20px;
    height: 20px;
  }
`;
const LastBox = styled.div`
  img {
    height: 15px;
  }
`;
const FirstText = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  /* Re_SPOQA/body/b_15 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 22.5px */
  letter-spacing: -0.3px;
`;

const Marker = styled.div`
  display: flex;
  padding: 1px 7px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #f0f8ff;
  color: #008aff;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 14.5px */
  letter-spacing: -0.2px;
`;

const LastText = styled.div`
  color: #f0f8ff;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;
